import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import {
  BankRecPayMonth,
  BankRecPayMonthFun,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Bank/BankSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function BankPaymentMonthWise({
  bankName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  const { BankRecPayMonthdata } = useSelector((state) => state.BankSlice);

  useEffect(() => {
    dispatch(BankRecPayMonthFun());
    dispatch(
      BankRecPayMonth({
        Firm,
        Year: YearId,
        selectedIds: accountGroup.join(","),
        BankIDs: bankName.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
  }, [Firm, YearId, accountGroup, bankName, endDate, startDate, dispatch]);

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const getRows = BankRecPayMonthdata?.PayMonthDtl?.map((label, index) => ({
    // srNumber: index + 1,
    BankName: label.BankName,
    Apr: label.Apr,
    May: label.May,
    Jun: label.Jun,
    Jul: label.Jul,
    Aug: label.Aug,
    Sep: label.Sep,
    Oct: label.Oct,
    Nov: label.Nov,
    Dec: label.Dec,
    Jan: label.Jan,
    Feb: label.Feb,
    Mar: label.Mar,
    Payment: formatIndianRupee(label.Payment),
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "BankName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Payment", key: "Payment", format: "true", align: "right" },
    { label: "Apr", key: "Apr", format: "true", align: "right" },
    { label: "May", key: "May", format: "true", align: "right" },
    { label: "Jun", key: "Jun", format: "true", align: "right" },
    { label: "Jul", key: "Jul", format: "true", align: "right" },
    { label: "Aug", key: "Aug", format: "true", align: "right" },
    { label: "Sep", key: "Sep", format: "true", align: "right" },
    { label: "Oct", key: "Oct", format: "true", align: "right" },
    { label: "Nov", key: "Nov", format: "true", align: "right" },
    { label: "Dec", key: "Dec", format: "true", align: "right" },
    { label: "Jan", key: "Jan", format: "true", align: "right" },
    { label: "Feb", key: "Feb", format: "true", align: "right" },
    { label: "Mar", key: "Mar", format: "true", align: "right" },
  ];

  if (BankRecPayMonthdata === "no" || BankRecPayMonthdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            margin: 0,
            padding: "14px",
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            BANK PAYMENT MONTHWISE
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
